import React, { useEffect } from "react";
import { BrowserRouter as Router, Route, Routes, useLocation } from "react-router-dom";
import Home from "./components/Home";
import Mpd from "./pages/Mpd";
import './index.css';
import AboutUsPage from "./pages/AboutUsPage";
import ContactUsPage from "./pages/ContactUsPage";
import TCPage from "./pages/TCPage";
import FeesPage from "./pages/FeesPage";
import StudentLifePage from "./pages/StudentLifePage";
import SMCPage from "./pages/SMCPage";
import RulesPage from "./pages/RulesPage";
import AdmissionEnquiryPage from "./pages/AdmissionEnquiryPage";
import SyllabusPage from "./pages/SyllabusPage";
import MissionAndVisionPage from "./pages/MissionAndVisionPage";
import FacultyPage from "./pages/FacultyPage";
import GalleryPage from "./pages/GalleryPage";
import UniformPage from "./pages/UniformPage";
import InfraPage from "./pages/InfraPage";
import HomeModal from "./HomeModal"; // Import the HomeModal component
import VisitingHourPage from "./pages/VisitingHourPage";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export default function App() {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        {/* Render the HomeModal component along with the Home component when the current route is the home page */}
        <Route path="/" element={<><Home /><HomeModal /></>} />
        <Route path="/mpd" element={<Mpd />} />
        <Route path="/AboutUsPage" element={<AboutUsPage/>} />
        <Route path="/ContactUsPage" element={<ContactUsPage/>}/>
        <Route path="/TCPage" element={<TCPage/>}/>
        <Route path="/FeesPage" element={<FeesPage/>}/>
        <Route path="/StudentLifePage" element={<StudentLifePage/>}/>
        <Route path="/SMCPage" element={<SMCPage/>}/>
        <Route path="/RulesPage" element={<RulesPage/>}/>
        <Route path="/AdmissionEnquiryPage" element={<AdmissionEnquiryPage/>}/>
        <Route path="/SyllabusPage" element={<SyllabusPage/>}/>
        <Route path="/MissionAndVisionPage" element={<MissionAndVisionPage/>}/>
        <Route path="/FacultyPage" element={<FacultyPage/>}/>
        <Route path="/GalleryPage" element={<GalleryPage/>}/>
        <Route path="/UniformPage" element={<UniformPage/>}/>
        <Route path="/InfraPage" element={<InfraPage/>}/>
        <Route path="/VistingHourPage" element={<VisitingHourPage/>}/>
      </Routes>
    </Router>
  );
}
